<template>
  <div>
    <AllOrders :selectedStatuses="statuses" :insuranceOnHold="true"></AllOrders>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllOrders = defineAsyncComponent(() =>
  import("@/components/orders/AllOrders")
);
export default {
  components: {
    AllOrders,
  },
  data() {
    return {
      statuses: ["ACTIVE", "PARTIAL"],
    };
  },
};
</script>
